import { Controller } from "@hotwired/stimulus"
import { motion, reducedMotion } from "../libs/motion"

// The last width of each bar the server sends again, so the new bar can spring from it.
const widths = new Map()

// A hugged bar springs to its new width when a label inside it changes, or when the
// server sends the bar again with new labels (that needs an id to match the two up).
// Its cells keep their own width, so they're what's watched; the bar centres them while
// it moves, so neither end clips more than the other.
export default class extends Controller {
  connect() {
    this.width = widths.get(this.element.id) ?? this.element.offsetWidth
    widths.delete(this.element.id)

    this.observer = new ResizeObserver(() => this.resize())
    for (const cell of this.element.children) this.observer.observe(cell)
  }

  disconnect() {
    this.observer.disconnect()
    if (this.element.id) widths.set(this.element.id, this.width)
  }

  resize() {
    const from = this.animation?.playState === "running" ? this.element.offsetWidth : this.width
    this.animation?.cancel()
    const to = this.width = this.element.offsetWidth

    // A bar on a hidden slide measures 0; it appears at its width rather than growing from nothing.
    if (!from || !to || from === to || reducedMotion()) return

    const frame = width => ({ width: `${width}px`, overflow: "hidden", justifyContent: "center" })
    this.animation = this.element.animate([ frame(from), frame(to) ], motion("spring"))
  }
}
